import React from 'react';
import type { IconProps } from './types';

export const LocationPinIcon: React.FunctionComponent<IconProps> = ({ size = 20, fill = '#ffffff', ...props }) => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512' width={`${size}`} height={`${size}`} {...props}>
			{/* <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--> */}
			<path
				fill={fill}
				d='M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z'
			/>
		</svg>
	);
};
